import { getTermsValue } from '../../helpers';
import { type TJsonQuery } from '../../types';

export const getRegionFromJsonQuery = (jsonQuery: TJsonQuery): number | undefined => {
  return getTermsValue('region')(jsonQuery)?.[0];
};
